import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LineUpCard from "./line-up-card";

const artists = [
  {
    name: "STEREOLAB",
    sort: "STEREOLAB",
    link: "https://stereolab.co.uk/",
    img: "Stereolab.jpg",
  },
  {
    name: "ALLAH-LAS",
    sort: "ALLAH LAS",
    link: "https://allahlas.com/",
    img: "Allah Las.jpg",
  },
  {
    name: "GWENNO",
    sort: "GWENNO",
    link: "https://www.gwenno.info/",
    img: "Gwenno.webp",
  },
  {
    name: "NIGHT TAPES",
    sort: "NIGHT TAPES",
    link: "https://nighttapesmusic.net/",
    img: "Night Tapes.jpg",
  },
  {
    name: "Karma Sheen",
    sort: "Karma Sheen",
    link: "https://open.spotify.com/artist/5jKjC91GYS58L8hhnDiC4j?autoplay=true",
    img: "KARMA_SHEEN_PHOTOS_SH-9.jpeg",
  },
  {
    name: "LAEL NEALE",
    sort: "LAEL NEALE",
    link: "https://laelneale.com/",
    img: "Lael Neale.webp",
  },
  {
    name: "THISTLE.",
    sort: "THISTLE.",
    link: "https://thistle.band/",
    img: "Thistle 1.jpg",
  },
  {
    name: "KNIVES",
    sort: "KNIVES",
    link: "https://open.spotify.com/artist/2YoHhPouaTT96k3dUQ8WZK",
    img: "Knives.webp",
  },
  {
    name: "FLORAL IMAGE",
    sort: "FLORAL IMAGE",
    link: "https://floralimageband.com/",
    img: "anna von 1 .png",
  },
  {
    name: "LEMONSUCKR",
    sort: "LEMONSUCKR",
    link: "https://lemonsuckr.com/",
    img: "Lemonsuckr.jpg",
  },
  {
    name: "MARTIAL ARTS",
    sort: "MARTIAL ARTS",
    link: "https://open.spotify.com/artist/6Io0X7BBqmDmJLaKbEq14E",
    img: "Martial Arts.webp",
  },
  {
    name: "HIGHDRIVE",
    sort: "HIGHDRIVE",
    link: "https://open.spotify.com/artist/2jT2rJpJiwpdC9IKlV5j5a",
    img: "HighDrive.png",
  },
  {
    name: "CORDELIA GARTSIDE",
    sort: "CORDELIA GARTSIDE",
    link: "https://open.spotify.com/artist/3dvaL6yNcqOneqRzb6UsBP",
    img: "cordelia_gartside.jpg",
  },
  {
    name: "SWALLOWTAIL",
    sort: "SWALLOWTAIL",
    link: "https://open.spotify.com/artist/7L88coHRD1ICTCtwHh6urt",
    img: "Swallowtail.jpg",
  },
  {
    name: "Bleech 9:3",
    sort: "Bleech 9:3",
    link: "https://bleech93.os.fan/",
    img: "Bleech 9-3.jpg",
  },

  {
    name: "White Denim",
    sort: "White Denim",
    link: "https://open.spotify.com/artist/0RdRumkn2UydUjqytNJ2Cp?si=Sl7zOl5gS3ioP9lWyAQ_4A",
    img: "WHITE DENIM.jpeg",
  },
  {
    name: "Anna von Hausswolff",
    sort: "Anna von Hausswolff",
    link: "https://open.spotify.com/artist/1eiXrvua27VlWgZ9kiaIn6?si=cB9MhIDiShiagOniVz5Nfg",
    img: "ANNA VAN HAUSSWOLFF.jpeg",
  },
  {
    name: "Automatic",
    sort: "Automatic",
    link: "https://open.spotify.com/artist/3uX1tstdmFJyxW9b5mSNlU?si=g4nNOOEgTQqaN4dmszCyJQ",
    img: "AUTOMATIC.jpg",
  },
  {
    name: "Mary in the Junkyard",
    sort: "Mary in the Junkyard",
    link: "https://open.spotify.com/artist/48Kc3HRodbvm5ropMf9B6M?si=7Td2LQvMROCZrnpdGXo7dg",
    img: "mary.jpg",
  },
  {
    name: "The Belair Lip Bombs",
    sort: "Belair Lip Bombs",
    link: "https://open.spotify.com/artist/6viWvP8YChO4DcOi1BpNvT?si=q3KUbJPCRnyJmflBBku7DA",
    img: "THE BEL AIR LIP BOMBS.jpg",
  },
  {
    name: "Hudson Freeman",
    sort: "Hudson Freeman",
    link: "https://open.spotify.com/artist/6k3W2iGuRZrhUnfVZOMQo8?si=b3oeZkptTL6mZ0umPa4zsA",
    img: "HUDSON FREEMAN_.jpeg",
  },
  {
    name: "Les Big Byrd",
    sort: "Les Big Byrd",
    link: "https://open.spotify.com/artist/3g2slv6elrXxGnXqy7Q2ap?si=txwHKchBRvqCEG3cJnChvw",
    img: "Les-Big-Byrd.jpg",
  },
  {
    name: "Sex Mask",
    sort: "Sex Mask",
    link: "https://open.spotify.com/artist/58TcB8X9Cr1VpR9PrXJeTQ?si=OzF3xFt3QjamwJ7ItdzTMg",
    img: "SEX MASK.jpeg",
  },
  {
    name: "The Dharma Chain",
    sort: "Dharma Chain",
    link: "https://open.spotify.com/artist/1vtBMVcsRYr8a4dJAmKtLB?si=bbHCrn6VRKGJjTmalPOgtg",
    img: "THE DHARMA CHAIN.jpeg",
  },
  {
    name: "Formal Speedwear",
    sort: "Formal Speedwear",
    link: "https://open.spotify.com/artist/6jGvuyheUzkEjJLHJopDuu?si=2HZzrZbQSE6USHQpPGNZow",
    img: "FORMAL SPPEDWEAR.webp",
  },
  {
    name: "Piss",
    sort: "Piss",
    link: "",
    img: "PISS.jpg",
  },
  {
    name: "Slag",
    sort: "Slag",
    link: "https://open.spotify.com/artist/5eGQYBSvZQ7242siSaU8v1?si=ZjCJu-xgQFOwmmXbhy1NNg",
    img: "SLAG.png",
  },
  {
    name: "Ellis D",
    sort: "Ellis D",
    link: "https://open.spotify.com/artist/6IYbOpElhnPpPnEQncHaxQ?si=IApU9eR1T-mLNhEDwFzFGA",
    img: "ELLIS - D.jpg",
  },

  {
    name: "ANNABELLE CHAIRLEGS",
    sort: "ANNABELLE CHAIRLEGS",
    link: "https://www.annabellechairlegs.com/",
    img: "Annabelle Chairlegs.jpg",
  },
  {
    name: "BONES ATE AFRA",
    sort: "BONES ATE AFRA",
    link: "https://open.spotify.com/artist/4FJzdOVGHmHQ8XKeO22ICA?si=KSj43SulTaK9Xxhj1F4Apg",
    img: "Bones Ate Afra.jpg",
  },
  {
    name: "THE HEAVENLY BODES",
    sort: "HEAVENLY BODES",
    link: "https://open.spotify.com/artist/3bvrrRepHGlIE8jV8bk7B5?si=z0wk_cDSS9-VgP0zw_27Fg",
    img: "The Heavenly Bodes.JPG",
  },
  {
    name: "HOLY WAVE",
    sort: "HOLY WAVE",
    link: "https://open.spotify.com/artist/0Cx9SrMKbfrkHvnqJLHq6b?si=7KfKkkPeRlWe5SZwmAT7yg",
    img: "HOLYWAVE (1).jpg",
  },
  {
    name: "THE KVB",
    sort: "KVB",
    link: "https://www.thekvb.co.uk/",
    img: "THE KVB 1.jpg",
  },
  {
    name: "LITTLE GRANDAD",
    sort: "LITTLE GRANDAD",
    link: "https://open.spotify.com/artist/1Mgr4JJnFwPk3FHbu09wAl?si=mvptTcY5S9SUvAlNBYLQsA",
    img: "LITTLE GRANDAD.jpg",
  },
  {
    name: "LTTL MORT",
    sort: "LTTL MORT",
    link: "https://www.instagram.com/lttlmort/",
    img: "lttl mort 2.jpeg",
  },
  {
    name: "LONNIE GUN",
    sort: "LONNIE GUN",
    link: "https://open.spotify.com/artist/3uuE1sz7PjwnzBKtK2YMEK?si=X1QqLmirS5WEhDu8fQN1lw",
    img: "lgun.jpg",
  },
  {
    name: "MANDY, INDIANA",
    sort: "MANDY INDIANA",
    link: "https://open.spotify.com/artist/2nDJxXJ7PtW7eLpFXcGH3u?si=pAPRxe2oT4G3uC56MUgxVg",
    img: "MANDY, INDIANA.jpg",
  },
  {
    name: "MAQUINA.",
    sort: "MAQUINA.",
    link: "https://open.spotify.com/artist/0U1D3GEq0HYA82J6WWw3DT?si=XfeWJWHLRL-sYeuq_DgQ2w",
    img: "Maquina.jpg",
  },
  {
    name: "MORN",
    sort: "MORN",
    link: "https://open.spotify.com/artist/0kyIsGsq7em6p0dOUwOAI3?si=Y7XgCFXFRwiaDpXbCKhoXQ",
    img: "MORN.jpg",
  },
  {
    name: "RINGLETS",
    sort: "RINGLETS",
    link: "https://open.spotify.com/artist/5CgTsJzu2AaHviFIlpoLwa?si=eWbglXkJSj-ivsYR1Cr7UQ",
    img: "Ringlets 1.jpg",
  },
  {
    name: "SILVERWINGKILLER",
    sort: "SILVERWINGKILLER",
    link: "https://www.instagram.com/slvrwngkllr/",
    img: "silverwingkiller.jpg",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function LineUp() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <div className="info-content">
        <Box sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}>
          {sortedArtists.map((artist) => (
            <LineUpCard key={artist.name} artist={artist} />
          ))}
        </Box>
      </div>
    </Container>
  );
}
export default LineUp;
